import { useEffect } from 'react';

// Shared keyboard map for presenter + preview modes.
export function usePresentationKeys(handlers, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => {
      if (e.target && ['INPUT', 'TEXTAREA'].includes(e.target.tagName)) return;
      const h = handlers;
      switch (e.key) {
        case 'ArrowRight': case 'PageDown': e.preventDefault(); h.next?.(); break;
        case 'ArrowLeft': case 'PageUp': e.preventDefault(); h.prev?.(); break;
        case ' ': e.preventDefault(); h.toggle?.(); break;
        case 'Escape': h.escape?.(); break;
        case 'Home': h.restart?.(); break;
        case 'f': case 'F': h.fullscreen?.(); break;
        case 'r': case 'R': h.restart?.(); break;
        case 't': case 'T': h.timer?.(); break;
        case 'm': case 'M': h.audio?.(); break;
        default: break;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [handlers, enabled]);
}

export function toggleFullscreen(el) {
  if (document.fullscreenElement) {
    document.exitFullscreen?.();
  } else {
    (el || document.documentElement).requestFullscreen?.().catch(() => {});
  }
}

export function scenePoster(scene) {
  const m = scene.media || {};
  return m.video?.poster || m.feeds?.[0]?.poster || m.reel?.poster || m.tiles?.[0]?.poster || m.postViewing?.poster
    || m.centre?.url || m.hero?.url || m.photographer?.url || m.thumbs?.[0]?.url || (scene.wall ? scene.wall[0].v.poster : '') || '';
}
